<template>
  <el-dialog class="dialog-simple" :visible.sync="visible" :title="dialogTitle" width="580px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" :size="size" ref="dataForm" label-position='right' label-width="120px" v-loading="dialogLoading">
      <el-form-item prop="remark" label="备注">
        <el-input v-model.trim="dataForm.remark" placeholder="请输入" clearable></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" slot="footer" style="text-align: right">
      <el-button class="submit" :size="size" type="primary" @click="submitHandle()" :loading="dialogLoading">确 定</el-button>
      <el-button class="close" :size="size" @click="visible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  name: 'rejectDialog',
  props: {
    dialogTitle: {
      type: String,
      default: '退回'
    },
    isRedispatch: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      size: 'small',
      dialogLoading: false,
      visible: false,
      baseList: [],
      dataForm: {
        orderId: 0,
        workBaseId: '',
        remark: ''
      },
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  methods: {
    init (row) {
      this.visible = true
      console.log(row.state)
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        this.dataForm = Object.assign({}, row)
      })
    },
    handleGetInfo () {
    },
    submitHandle:debounce (function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.dialogLoading = true
        let backToState = 0
        let state = this.dataForm.status ? this.dataForm.status : this.dataForm.state
        switch (state) {
          case 1:
            backToState = 9
            break
          case 9:
            backToState = 8
            break
          case 6:
            backToState = 5
          case 10:
            backToState = 5
            break
        }
        const id = this.dataForm.workOrderId ? this.dataForm.workOrderId : this.dataForm.id
        // console.log(
        //   id,
        //   backToState,
        //   this.dataForm.remark
        // )
        this.$api.electricOperations.changeElectricOperationsWorkOrderState(
          id,
          backToState,
          this.dataForm.remark
        ).then((res) => {
          this.dialogLoading = false
          if (res.success) {
            this.visible = false
            this.$message.success('操作成功')
            this.$emit('handleQuery')
          }
        }).catch(() => this.dialogLoading = false)
      })
    }, 1000, { 'leading': true, 'trailing': false } )
  }
}
</script>

<style lang="scss" scoped>
</style>
